// obhliadka_polia.js — SPOLOČNÉ ČÍSELNÍKY OBHLIADKY pre mview (ObhliadkaMobile) aj desktop
// (ObhliadkaEditor). JEDNA definícia — ústava 103.D (Mirko 27.7.: rovnaký obsah polí všade;
// obhliadka sa dá spraviť aj po telefóne, desktop musí mať všetky náležitosti ako mview).

export const INFORMUJ = [
  'Otvory rátame ako celé m²',
  'Výsledná kvalita Q3',
  'V cene všetko podľa TP + upratanie (nie vývoz odpadu)',
  'VC omietka — možnosť mikrotrhlín',
  'Sadra — drobné výspravky pred maľovaním',
  'Možná nadspotreba materiálu',
  'Potrebná tlaková voda + elektrika (25A/32A)',
  'Maľovanie od 2,99 €/m²',
  'Potery: anhydrid ~14 €/m² · cement ~11 €/m² + doprava',
  'Doprava materiálu podľa skutočnej faktúry zo stavebnín',
]

// Poterový „informuj zákazníka" (Mirko 27.7. nadiktoval — omietkarský zoznam sem nepatrí)
export const POTER_INFORMUJ = [
  'Výmera sa ráta spôsobom pôdorys a × b',
  'V cene nie je zahrnutá likvidácia odpadu po realizácii',
  'Možná nadspotreba materiálu — dopláca sa iba materiál, nie práca',
  'Teplota pri aplikácii min. +5 °C (neleje sa nad 30 °C), zabrániť priamemu slnku a prievanu po realizácii — nechať zatvorené prvých 48 hodín',
]

// Body 1–6 z Denník → Poterový protokol — pri OBHLIADKE len INFORMOVANIE zákazníka vopred
// (nie overenie stavu; to rieši až protokol pri realizácii).
export const POTER_CHECKLIST = [
  { key: 'min_vyska', label: 'Min. výška — najtenšie miesto ≥ TL minimum nad kúrením' },
  { key: 'vanicka', label: 'Fólia + dilatačný pás zvárané/prelepené = vaňička (netečie pod izoláciu)' },
  { key: 'kurenie', label: 'Kúrenie 100 % ukotvené (nedvíhajú sa rúrky pri liatí)' },
  { key: 'okraje', label: 'Okrajové dilatačné pásky (5–7 mm / 10 mm)' },
  { key: 'podklad', label: 'Podklad čistý — odstránené zvyšky polystyrénu a nečistôt' },
  { key: 'prievan', label: 'Bez prievanu a cirkulácie vzduchu (min. 24 h)' },
]

// Možnosti chips-výberov — rovnaké poradie a texty ako mview.
export const OPT = {
  druh_nehnutelnosti: ['RD', 'BD', 'Hala', 'Iné'],
  stav_objektu: ['Novostavba', 'Rekonštrukcia'],
  murivo: ['Pórobetón', 'Tehla', 'Monolit', 'Iné'],
  realizacia: ['Exteriér', 'Interiér'],
  druh_omietky: ['Sadrové obyč.', 'Sadrové diamant', 'Vápennocementové', 'KlimaWhite', 'Jadrová', 'Iné'],
  poter_material: ['Anhydrit', 'Cement'],
  voda: ['Studňa', 'Obecná voda'],
  elektrika: ['Istič min. 25A', '32A fľaša', 'Iné'],
  pristup: ['Úzky dvor', 'Nespevnená cesta', 'Iné'],
  robil: ['Jurkovský', 'Kašubjak', 'Kopeček', 'Iný'],
}
